import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <section id="about" className="py-12 md:py-16 bg-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block mb-4">
            <span className="text-forest font-semibold text-sm tracking-widest uppercase">About Me</span>
            <div className="h-1 w-16 bg-forest mt-2 mx-auto"></div>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-forest mb-6 leading-tight">
            Crafting Visual Stories
          </h2>
          <p className="text-lg md:text-xl text-secondary leading-relaxed mb-8">
            We believe in creating and capturing every special moment that needs to be remembered. With over 5 years of experience in photography we take every step to ensure every emotion and feeling is felt in our work. Book us now and receive a free quote!
          </p>
          <Link 
            to="/contact" 
            className="inline-block bg-forest text-white font-semibold px-8 py-4 rounded-full shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
          >
            Let's Work Together
          </Link>
        </div>
      </div>
    </section>
  );
};

export default About;
